import React from 'react'

import styles from './DesktopInstallFlowCard.module.scss'

interface DesktopInstallFlowCardProps {
  icon: string
  text: React.ReactNode
}

export const DesktopInstallFlowCard: React.FC<DesktopInstallFlowCardProps> = ({ icon, text }) => {
  return (
    <div className={styles.card}>
      <img src={icon} alt="" className={styles.icon} />
      <div className={styles.text}>
        {text}
      </div>
    </div>
  )
}